module.exports = __webpack_public_path__ + "img/KinokoTable20.04a4e369.jpg";